;(function (window) {
    console.log('Language translations loaded');

    const resources = {
        en: {
            translation: {
                checkoutTimeAlert: 'It is not possible to place an order to the selected time',
                checkoutClosedAlert: 'The store is closed, please try again later',
                storeIsClosed: 'The store is closed, please try again later',
                alertTOS: 'Please read and accept the terms of service',
                alertContactPerson: 'Please select a contact person',
                invalidPhoneNumber: 'Invalid phone number!',
                anErrorOccurred: 'An error occurred',
                modalCloseButton: 'Close',
                extraProductsWholeNumber: 'Additional products can only be ordered in whole quantities.',
                extraProductsInvalidProductID: 'Invalid productID',
                wrongCode: 'Wrong code!',
                somethingWentWrong: 'Something went wrong, please reload the page and try again',
                deleteCustomFont: 'Are you sure you want to delete this custom font? Standard fonts will be used instead.',
                deleteCustomFontConfirmation: 'Font was deleted!',
                saveCustomFont: 'Font was saved!',
                deleteCustomColor: 'Are you sure you want to delete your custom colors? Standard colors will be used instead.',
                deleteCustomColorConfirmation: 'Your colors were deleted!',
                saveCustomColor: 'Custom colors were saved!',
                closeStoreConfirmation: 'Are you sure you want to close the store? customer will not be able to add products to cart or place orders. You can open the store again at any time',
                closeStore: 'The store was closed!',
                closeStoreMessage: 'Customer cannot add products to the cart or place orders. OBS: The store must be opened manually.',
                openStoreConfirmation: 'Are you sure you want to open the store? customer will be able to add products to cart and place orders. You can close the store again at any time',
                openStore: 'The store was opened!',
                openStoreMessage: 'Customer can add products to the cart and place orders again.',
                saveMessage: 'Saved!',
                errorTableMessage: 'You cannot have a table without columns',
                changeOrderSuccess: 'Order changed',
                changeOrderFail: 'Something went wrong, please reload the page and try again. If the problem persists, please contact our support department.',
                emptyShoppingCart: 'Do you want to empty the shopping cart and start over?',
                invalidNumber: 'Invalid number: ',
                invalidNumberMessage: 'check the number you entered. Only whole numbers are allowed',
                confirmChange: 'Changing this might affect the products in the cart. Are you sure you want to continue?',
                readMore: 'Read more...',
                savedTextMessage: 'The text was saved!',
                closeSale: 'Close sale',
                openSale: 'Open sale',
                chooseTimeDate: 'Please choose a date and time for when the store will be closed.',
                closeStoreToDateConfirm: 'Are you sure you want to close the store to ',
                closeStoreToInfo: '? Customer cannot add products to the cart or place orders. You can open the store again at any time.',
                saleClosedTo: 'The store was closed to ',
                noHits: 'No hits',
                extraCategoryFormProductsListButtonAdd: 'Add',
                extraCategoryFormProductsListButtonDelete: 'Delete',
                extraCategoryListSortPriority: 'Sorting priority is saved',
                extraCategoryListSortPriorityError: 'Sorting priority is not saved',
                extraCategoryGetError: 'Could not get extra category',
                extraCategoryCreateError: 'Could not create extra category',
                extraCategoryUpdateError: 'Could not update extra category',
                extraCategoryDeleteError: 'Could not delete extra category',
                extraCategoryProductsSearchError: 'Error occurred',
                extraCategoryDeleteConfirm: 'Do you want to delete extra category',
                extraCategorySearchError: 'Error occurred',
                departmentGetError: 'Could not get department',
                departmentCreateError: 'Could not create department',
                departmentUpdateError: 'Could not update department',
                departmentDeleteError: 'Could not delete department',
                departmentsSearchError: 'Error occurred',
                departmentDeleteConfirm: 'Do you want to delete department',
            }

        },
        no: {
            translation: {
                checkoutTimeAlert: 'Det er dessverre ikke mulig å bestille til valgt tidspunkt',
                checkoutClosedAlert: 'Vi tar dessverre ikke imot bestillinger akkurat nå fordi vi har stengt, men du er velkommen tilbake senere',
                storeIsClosed: 'Serveringsstedet er stengt',
                alertTOS: 'Du må lese og akseptere kjøpsvilkårene',
                alertContactPerson: 'Du må velge en kontaktperson',
                invalidPhoneNumber: 'Ugyldig mobilnummer!',
                anErrorOccurred: 'Det oppsto en feil',
                modalCloseButton: 'Lukk',
                extraProductsWholeNumber: 'Ekstraprodukter kan kun bestilles i hel antall',
                extraProductsInvalidProductID: 'Ugyldig produktID',
                wrongCode: 'Feil kode!',
                somethingWentWrong: 'Noe gikk feil. Last siden på nytt og prøv igjen',
                deleteCustomFont: 'Er du sikker på at du vil slette egendefinert skrifttype? Standard skrifttype vil gjelde for nettsiden.',
                deleteCustomFontConfirmation : 'Skrifttype ble slettet!',
                saveCustomFont: 'Skrifttype ble lagret!',
                deleteCustomColor: 'Er du sikker på at du vil slette dine egendefinerte farger? Standard farger vil gjelde for nettsiden.',
                deleteCustomColorConfirmation: 'dine farger ble slettet!',
                saveCustomColor: 'Egendefinerte farger ble lagret!',
                closeStoreConfirmation: 'Er du sikker på at du vil stenge nettbutikken? Kunder kan ikke legge varer i handlekurven eller legge inn nye bestillinger. Du kan når som helst åpne igjen.',
                closeStore: 'Salget ble stengt!',
                closeStoreMessage: 'Kunder i nettbutikken får IKKE lov til å legge varer i handlekurven eller legge inn nye bestillinger. OBS: Må åpnes manuelt.',
                openStoreConfirmation: 'Er du sikker på at du vil åpne nettbutikken? Kunder vil da kunne legge varer i handlekurven og legge inn nye bestillinger. Du kan når som helst stenge igjen.',
                openStore: 'Salget ble åpnet!',
                openStoreMessage: 'Kunder i nettbutikken kan nå legge varer i handlekurv og legge inn nye bestillinger igjen.',
                saveMessage: 'Lagret!',
                errorTableMessage: 'Du kan ikke ha en tabell uten kolonner',
                changeOrderSuccess: 'Rekkefølge endret',
                changeOrderFail: 'Kunne dessverre ikke endre rekkefølgen. Prøv å last siden på nytt og prøv igjen. Hvis problemet vedvarer, vennligst ta kontakt med vår supportavdeling.',
                emptyShoppingCart: 'Vil du tømme handlekruv og starte på nytt?',
                invalidNumber: 'Ugyldig antall: ',
                invalidNumberMessage: 'Kontroller antallet som er skrevet inn. Kun heltall er lov',
                confirmChange: 'Dersom du endrer denne nå, kan det påvirke varene du har lagt i handlekurven',
                readMore: 'Vis mer...',
                savedTextMessage: 'Teksten ble lagret!',
                closeSale: 'Steng salg',
                openSale: 'Åpne salg',
                chooseTimeDate: 'Vennligst velg dato og klokkeslett for når netbutikken skal stenges.',
                closeStoreToDateConfirm: 'Er du sikker på at du vil stenge nettbutikken til ',
                closeStoreToInfo: '? Kunder kan ikke legge varer i handlekurven eller legge inn nye bestillinger. Du kan når som helst åpne igjen.',
                saleClosedTo: 'Salget ble stengt til ',
                noHits: 'Ingen treff',
                extraCategoryFormProductsListButtonAdd: 'Legg til',
                extraCategoryFormProductsListButtonDelete: 'Slett',
                extraCategoryListSortPriority: 'Sorteringsprioritet er lagret',
                extraCategoryListSortPriorityError: 'Sorteringsprioritet er ikke lagret',
                extraCategoryGetError: 'Kunne ikke hente ekstra kategori',
                extraCategoryCreateError: 'Kunne ikke opprette ekstra kategori',
                extraCategoryUpdateError: 'Kunne ikke oppdatere ekstra kategori',
                extraCategoryDeleteError: 'Kunne ikke slette ekstra kategori',
                extraCategoryProductsSearchError: 'Feil oppsto',
                extraCategoryDeleteConfirm: 'Vil du slette ekstra kategori',
                extraCategorySearchError: 'Feil oppsto',
                departmentGetError: 'Kunne ikke hente avdeling',
                departmentCreateError: 'Kunne ikke opprette avdeling',
                departmentUpdateError: 'Kunne ikke oppdatere avdeling',
                departmentDeleteError: 'Kunne ikke slette avdeling',
                departmentsSearchError: 'Feil oppsto',
                departmentDeleteConfirm: 'Vil du slette avdeling',
            }
        }
    };

    function initI18n(defaultLang) {
        defaultLang = defaultLang || 'no';
        return new Promise(function(resolve, reject){
            i18next.init({
                resources: resources,
                lng: defaultLang,
                fallbackLng: 'en',
                interpolation: { escapeValue: false }
            }, function(err, t){
                if (err) return reject(err);
                resolve();
            });
        });
    }

    function changeLanguageJS(newLang) {
        return new Promise(function(resolve, reject){
            i18next.changeLanguage(newLang, function(err, t){
                if (err) return reject(err);
                resolve();
            });
        });
    }

    function t(key) {
        return i18next.t(key);
    }

    window.initI18n = initI18n;
    window.changeLanguageJS = changeLanguageJS;
    window.t = t;
})(window);